import styled from "styled-components";
import { Anchor, Type } from "discover.medical.react-component-library";

export const StyledLabel = styled(Type)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    text-transform: uppercase;
    font-weight: ${({ theme }) => theme.font.weight.semibold};
  }
`;

export const StyledLink = styled(Anchor)`
  display: block;
  margin-top: ${({ theme }) => theme.space.sm};
`;
